// src/pages/ContactPage.js
import React from 'react';
import Layout from '../components/Layout/Layout';

const ContactPage = () => {
  return (
    <Layout>
      <div id="contact-us" className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px', minHeight: '600px', textAlign: 'center' }}>
        
        <h1 style={{ color: '#004488', fontSize: '2.8rem', fontWeight: 'bold', marginBottom: '10px' }}>
          Contact Us
        </h1>
        <div style={{ width: '80px', height: '4px', backgroundColor: '#add8e6', margin: '0 auto 40px auto' }}></div>

        {/* General Enquiries Box */}
        <div style={{
          backgroundColor: '#e3f2fd',
          border: '1px solid #bbdefb',
          borderRadius: '12px',
          padding: '40px 20px',
          marginBottom: '60px',
          maxWidth: '1000px',
          margin: '0 auto 60px auto',
          boxShadow: '0 4px 15px rgba(0,0,0,0.03)'
        }}>
          <h2 style={{ color: '#004488', fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px' }}>
            General Enquiries
          </h2>
          <div style={{ color: '#333', fontSize: '1.1rem', lineHeight: '2' }}>
            <p><strong>Email:</strong> <a href="mailto:latesanjaytompe_802@rediffmail.com" style={{ color: '#555', textDecoration: 'none' }}>latesanjaytompe_802@rediffmail.com</a></p>
            <p><strong>Phone:</strong> 9049703918</p>
            <p style={{ maxWidth: '850px', margin: '0 auto' }}>
              <strong>Address:</strong> Late Sanjay Tompe and Late Sameer Deshmukh B.Ed College of Education, Chandur Bazar, Amravati, Maharashtra, India
            </p>
            <p><strong>Working Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM (IST)</p>
          </div>
        </div>

        {/* Our Location Section */}
        <h2 style={{ color: '#004488', fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '30px' }}>
          Our Location
        </h2>

        <div style={{ 
          maxWidth: '1000px', 
          margin: '0 auto 20px auto', 
          borderRadius: '12px', 
          overflow: 'hidden', 
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          border: '1px solid #eee',
          position: 'relative'
        }}>
          <iframe 
            title="College Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.091689954329!2d77.7424614!3d21.2282124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd68ff778cbd183%3A0xe2a1d13d2dc83122!2sG%20S%20Tompe%20Arts%2C%20Commerce%2C%20Science%20College!5e0!3m2!1sen!2sin!4v1712398658314!5m2!1sen!2sin" 
            width="100%" 
            height="500" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <p style={{ color: '#666', fontSize: '1.05rem', marginTop: '20px', marginBottom: '40px' }}>
          You can find us easily using the map above. Feel free to visit us during working hours.
        </p>

      </div>
    </Layout>
  );
};

export default ContactPage;
